import { http } from '@/utils/http';
import qs from 'qs';
import { isWeiXin } from '@/common/ts/common';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q4/2024SweetTiger/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (
  type: number,
  page: number,
  order: any,
  keyword?: string,
) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      workType: type,
      page,
      search: keyword,
      order,
    },
  });
};

const getDetail = (id: number | string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
const getType = () => {
  return http.get(`${urlPrefix}getWorkType`);
};

// 获取区域
const getAreas = () => {
  return http.get(`${urlPrefix}getAreas`);
};

//
const getUser = () => {
  return http.get(`${urlPrefix}vote-list-user`);
};

const save = (data: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getRank = (type: string | number, page: string | number) => {
  return http.get(`${urlPrefix}rank`, {
    params: {
      type,
      page,
    },
  });
};
const nextLastId = (id: any, type: any) => {
  return http.get(`${urlPrefix}nextLastId`, {
    params: {
      id,
      workType: type,
    },
  });
};

// 获取所有学校
const getSchools = (val?: string) => {
  return http.get(`${urlPrefix}getSchools&search=${val}`);
};
// 获取数据统计量
const getTotalData = () => {
  return http.get(`${urlPrefix}Statistics`);
};
const addPageView = () => {
  return http.get(`${urlPrefix}addRead`);
};
const share = (context: any) => {
  context.$appShareInfo({
    title: '2024甜甜虎春节行动',
    url: location.href,
    subtitle: '2024甜甜虎春节行动',
    classId: -1,
    id: -1,
    image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    type: 3,
  });
  // 微信分享
  if (isWeiXin()) {
    context.$wxShareInfo({
      title: '2024甜甜虎春节行动',
      subtitle: '2024甜甜虎春节行动',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
};
const luckDraw = (data: any) => {
  return http.post(`${urlPrefix}luckDraw`, qs.stringify(data));
};

const messageSave = (data: any) => {
  return http.post(`${urlPrefix}messageSave`, qs.stringify(data));
};

const userPrize = () => {
  return http.get(`${urlPrefix}userPrize`);
};
const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const TEST_TOKEN = `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vdGVzdGFwaS5jcWNiLmNvbS9hcGkvdXNlci9sb2dpbiIsImlhdCI6MTYwNjA5OTMyNiwiZXhwIjoxOTY2MDk5MzI2LCJuYmYiOjE2MDYwOTkzMjYsImp0aSI6ImJVRHFkRnNPbHc2ZkdORDUiLCJzdWIiOjg3NTM2MywicHJ2IjoiODY2NWFlOTc3NWNmMjZmNmI4ZTQ5NmY4NmZhNTM2ZDY4ZGQ3MTgxOCJ9.NFbLN2ZIp4Fc4BWGjIoTH6YSoxf78x1nUiU0aBEBaSc`;
export {
  getBaseInfo,
  getRule,
  getVoteList,
  getDetail,
  save,
  getAreas,
  getType,
  getUser,
  getRank,
  share,
  nextLastId,
  getSchools,
  getTotalData,
  addPageView,
  luckDraw,
  messageSave,
  userPrize,
  getNews,
};
